import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Landing from './views/Landing';
import Services from './views/Services';
import Clients from './views/Clients';
import Team from './views/Team';
import Testmonials from './views/Testimonials';
import Contact from './views/Contact';
import Firm from './views/Firm';
import News from './views/News';

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route exact path="/firm" component={Firm} />
      <Route exact path="/services" component={Services} />
      <Route exact path="/clients" component={Clients} />
      <Route exact path="/team" component={Team} />
      <Route exact path="/testimonials" component={Testmonials} />
      <Route exact path="/contact" component={Contact} />
      <Route exact path="/news" component={News} />
      <Redirect to="/" />
    </Switch>
  );
};

export default Routes;
